(function () {
  'use strict';

  function createEntityController($scope, $log, $timeout, $rootScope, $location, $window,
    $filter, sessionData, platformEntityTypes, STATES_LIST, entityDataService, notifyService) {

    var vm = this;
    vm.sessionData = sessionData;
    vm.statesList = STATES_LIST;
    vm.platformEntityTypes = platformEntityTypes;

    vm.entityType = $filter('underscoresToCamelCase')($rootScope.$state.params.entityType);

    vm.model = {
      AccountType: vm.entityType.replace(' ','')
    };

    vm.errors = [];
    vm.submit = function() {
      vm.hideButtons = true;
      if (!vm.model.CompanyDetails.State) {
        vm.errors = ["State is missing"];
        return;
      }

      if (vm.model.AccountType === "PlatformEntity" && !vm.model.EditableEntityType) {
        vm.errors = ["EntityType is missing"];
        return;
      }

      return entityDataService.createEntity(vm.model).then(
        function (result) {
          if (result.isError) {
            vm.errors = [];
            Object.keys(result.data.Errors).forEach(function(key) {
              vm.errors = vm.errors.concat(result.data.Errors[key]);
            });
            vm.hideButtons = false;
          }
          else {
            vm.hideButtons = true;
            vm.errors = [];
            notifyService.notify('The new account was created successfully and the user was sent a registration email. You are being redirected to their dashboard.');
            $timeout(function () {
              $window.location = '/crm/accounts/details/' + result.EntityId.toLowerCase();
            }, 2000);
          }
        }
      )
    }
  }

  createEntityController.$inject = [
    '$scope', '$log', '$timeout', '$rootScope', '$location', '$window', '$filter',
    'sessionData', 'platformEntityTypes', 'STATES_LIST', 'entityDataService', 'notifyService'
  ];

  angular.module('ecap.crm').controller('createEntityController', createEntityController);
})();